// extracted by mini-css-extract-plugin
export default {"wrapper":"Hp-z","response":"Ip-z","error":"Jp-z","disabled":"Kp-z","buttons":"Lp-z","feedbackQuestionSection":"Mp-z","yesNoWrapper":"Np-z"};